module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "next-gen-article"
  }, [_c('div', {
    attrs: {
      "id": "headerPlaceholder"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "article__header"
  }, [_c('div', {
    staticClass: "article__container article__header--container"
  }, [_c('router-link', {
    staticClass: "article__header--button",
    attrs: {
      "to": {
        name: 'articles-list'
      }
    }
  }, [_c('svg', {
    staticClass: "svg-inline--fa fa-arrow-left fa-w-14",
    attrs: {
      "aria-hidden": "true",
      "focusable": "false",
      "data-prefix": "fas",
      "data-icon": "arrow-left",
      "role": "img",
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 448 512"
    }
  }, [_c('path', {
    attrs: {
      "fill": "currentColor",
      "d": "M257.5 445.1l-22.2 22.2c-9.4 9.4-24.6 9.4-33.9 0L7 273c-9.4-9.4-9.4-24.6 0-33.9L201.4\n            44.7c9.4-9.4 24.6-9.4 33.9 0l22.2 22.2c9.5 9.5 9.3 25-.4 34.3L136.6 216H424c13.3 0 24 10.7 24 24v32c0 13.3-10.7 24-24\n            24H136.6l120.5 114.8c9.8 9.3 10 24.8.4 34.3z"
    }
  })]), _vm._v("\n        Back\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "article__header--actions"
  }, [_c('button', {
    staticClass: "blue-border-btn",
    on: {
      "click": function($event) {
        return _vm.publishArticle(_vm.entity.status, true, false)
      }
    }
  }, [_vm._v("Preview")]), _vm._v(" "), _c('button', {
    staticClass: "light-blue-btn",
    on: {
      "click": function($event) {
        return _vm.publishArticle(0)
      }
    }
  }, [_vm._v("Save as Draft")]), _vm._v(" "), _c('button', {
    staticClass: "dark-blue-btn",
    on: {
      "click": function($event) {
        return _vm.publishArticle(1)
      }
    }
  }, [_vm._v("Publish")]), _vm._v(" "), _c('button', {
    staticClass: "gray-border-btn",
    on: {
      "click": function($event) {
        return _vm.goToAllArticles()
      }
    }
  }, [_vm._v("Exit without saving")])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "article__content"
  }, [_c('div', {
    staticClass: "article__container"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "article__content--editor"
  }, [_c('div', {
    staticClass: "article__content--box"
  }, [_c('div', {
    staticClass: "article__content--box__head",
    class: [{
      'active': _vm.articleEditBoxActive
    }]
  }, [_c('div', {
    staticClass: "article__content--box__head--title"
  }, [_vm._v("Edit article")]), _vm._v(" "), _c('button', {
    staticClass: "article__content--box__head--action",
    attrs: {
      "aria-expanded": _vm.articleEditBoxActive
    },
    on: {
      "click": function($event) {
        _vm.articleEditBoxActive = !_vm.articleEditBoxActive
      }
    }
  }, [_c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "14.096",
      "height": "8.048",
      "viewBox": "0 0 14.096 8.048"
    }
  }, [_c('path', {
    attrs: {
      "fill": "currentColor",
      "d": "M.875-3.25.188-4A.665.665,0,0,1,.25-5.062l6.313-5.781a.6.6,0,0,1,.875,0L13.75-5.062A.665.665,0,0,1,13.813-4l-.687.75a.637.637,0,0,1-.5.266.672.672,0,0,1-.531-.2L7-7.875,1.906-3.187a.672.672,0,0,1-.531.2A.637.637,0,0,1,.875-3.25Z",
      "transform": "translate(0.048 11.031)"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "article__content--box__content",
    attrs: {
      "aria-expanded": _vm.articleEditBoxActive
    }
  }, [_c('div', {
    staticClass: "article__form-group"
  }, [_c('div', {
    staticClass: "article__form-group--sixth"
  }, [_c('div', {
    staticClass: "article__form-element"
  }, [_c('label', {
    staticClass: "article__form-label"
  }, [_vm._v("Article content")]), _vm._v(" "), _c('Vueditor', {
    ref: "contentEditor",
    staticClass: "form-control__editor"
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "article__form-group--fourth"
  }, [_c('div', {
    staticClass: "article__form-element"
  }, [_c('label', {
    staticClass: "article__form-label",
    attrs: {
      "for": "title"
    }
  }, [_vm._v("Title")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.title),
      expression: "entity.title"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control form-control__input",
    class: [{
      'has-error': _vm.errors.has('Title')
    }],
    attrs: {
      "type": "text",
      "data-lpignore": "true",
      "id": "title",
      "data-vv-name": "Title",
      "name": "title"
    },
    domProps: {
      "value": (_vm.entity.title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity, "title", $event.target.value)
      }
    }
  }), _vm._v(" "), (this.errors.has('Title')) ? _c('span', {
    staticClass: "form-field-error"
  }, [_vm._v(_vm._s(this.errors.first('Title')))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "article__form-element"
  }, [_c('label', {
    staticClass: "article__form-label",
    attrs: {
      "for": "topic"
    }
  }, [_vm._v("Topic")]), _vm._v(" "), _c('v-select', {
    staticClass: "form-control form-control__select",
    class: [{
      'has-error': _vm.errors.has('Topic')
    }],
    attrs: {
      "searchable": true,
      "multiple": true,
      "options": _vm.getTagsForSelect,
      "data-vv-name": "Topic",
      "data-lpignore": "true",
      "name": "topic",
      "id": "topic"
    },
    model: {
      value: (_vm.entity.topic),
      callback: function($$v) {
        _vm.$set(_vm.entity, "topic", $$v)
      },
      expression: "entity.topic"
    }
  }), _vm._v(" "), (this.errors.has('Topic')) ? _c('span', {
    staticClass: "form-field-error"
  }, [_vm._v(_vm._s(this.errors.first('Topic')))]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "article__form-element"
  }, [_c('label', {
    staticClass: "article__form-label",
    attrs: {
      "for": "category"
    }
  }, [_vm._v("Category")]), _vm._v(" "), _c('v-select', {
    staticClass: "form-control form-control__select",
    class: [{
      'has-error': _vm.errors.has('Category')
    }],
    attrs: {
      "searchable": true,
      "multiple": false,
      "options": _vm.getCategoriesForSelect,
      "data-vv-name": "Category",
      "data-lpignore": "true",
      "name": "category",
      "id": "category"
    },
    model: {
      value: (_vm.entity.category),
      callback: function($$v) {
        _vm.$set(_vm.entity, "category", $$v)
      },
      expression: "entity.category"
    }
  }), _vm._v(" "), (this.errors.has('Category')) ? _c('span', {
    staticClass: "form-field-error"
  }, [_vm._v(_vm._s(this.errors.first('Category')))]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "article__form-element"
  }, [_c('label', {
    staticClass: "article__form-label",
    attrs: {
      "for": "type"
    }
  }, [_vm._v("Type")]), _vm._v(" "), _c('v-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control form-control__select",
    class: [{
      'has-error': _vm.errors.has('Type')
    }],
    attrs: {
      "searchable": false,
      "options": _vm.getContentTypeForSelect,
      "data-vv-name": "Type",
      "data-lpignore": "true",
      "name": "type",
      "id": "type"
    },
    model: {
      value: (_vm.entity.type),
      callback: function($$v) {
        _vm.$set(_vm.entity, "type", $$v)
      },
      expression: "entity.type"
    }
  }), _vm._v(" "), (this.errors.has('Type')) ? _c('span', {
    staticClass: "form-field-error"
  }, [_vm._v(_vm._s(this.errors.first('Type')))]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "article__form-element"
  }, [_c('div', {
    staticClass: "article__form-group"
  }, [_c('div', {
    staticClass: "article__form-element article__featured-image"
  }, [_c('span', {
    staticClass: "article__form-label"
  }, [_vm._v("Featured image")]), _vm._v(" "), _c('label', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isThumbnailFileUploaded),
      expression: "!isThumbnailFileUploaded"
    }],
    staticClass: "article__form-label article__form-label--file-upload"
  }, [_c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "32",
      "height": "24",
      "viewBox": "0 0 32 24"
    }
  }, [_c('path', {
    attrs: {
      "fill": "currentColor",
      "d": "M29,0a3,3,0,0,0,3-3V-21a3,3,0,0,0-3-3H3a3,3,0,0,0-3,3V-3A3,3,0,0,0,3,0ZM7-20.5A3.5,3.5,0,0,1,10.5-17,3.5,3.5,0,0,1,7-13.5,3.5,3.5,0,0,1,3.5-17,3.5,3.5,0,0,1,7-20.5ZM4-4V-7l4.47-4.47a.75.75,0,0,1,1.061,0L13-8l8.47-8.47a.75.75,0,0,1,1.061,0L28-11v7Z",
      "transform": "translate(0 24)"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "upload-text"
  }, [_vm._v("Upload image")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate.reject",
      value: (_vm.veeValidateFileUploadRules),
      expression: "veeValidateFileUploadRules",
      modifiers: {
        "reject": true
      }
    }],
    staticClass: "form-control form-control--file",
    attrs: {
      "type": "file",
      "id": "uploadThumbnail",
      "name": "Thumbnail",
      "data-vv-as": "\"Thumbnail\"",
      "value.sync": "formInfo.thumbnail"
    },
    on: {
      "change": function($event) {
        return _vm.onThumbnailFileChange($event)
      }
    }
  })]), _vm._v(" "), (_vm.isThumbnailFileUploaded) ? _c('div', {
    style: ({
      backgroundImage: 'url(' + _vm.featuredImage + ')'
    }),
    attrs: {
      "id": "thumbnailFilePreview"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isThumbnailFileUploaded) ? _c('button', {
    staticClass: "btn btn--remove-element",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.removeThumbnail
    }
  }, [_c('span', {
    staticClass: "btn__text"
  }, [_vm._v("-Remove image")])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "article__form-element"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.altImage),
      expression: "entity.altImage"
    }],
    staticClass: "form-control form-control__textarea has-no-label",
    class: {
      'is-blocked': !_vm.isThumbnailFileUploaded
    },
    attrs: {
      "disabled": !_vm.isThumbnailFileUploaded,
      "data-lpignore": "true",
      "id": "image",
      "placeholder": _vm.isThumbnailFileUploaded ? 'Type in Alt text for the image...' : '',
      "data-vv-name": "Image alt",
      "name": "title"
    },
    domProps: {
      "value": (_vm.entity.altImage)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity, "altImage", $event.target.value)
      }
    }
  })])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "article__content--box__container"
  }, [_c('div', {
    staticClass: "article__content--box"
  }, [_c('div', {
    staticClass: "article__content--box__head",
    class: [{
      'active': _vm.articleSettingsBoxActive
    }]
  }, [_c('div', {
    staticClass: "article__content--box__head--title"
  }, [_vm._v("Access Settings")]), _vm._v(" "), _c('button', {
    staticClass: "article__content--box__head--action",
    attrs: {
      "aria-expanded": _vm.articleSettingsBoxActive
    },
    on: {
      "click": function($event) {
        _vm.articleSettingsBoxActive = !_vm.articleSettingsBoxActive
      }
    }
  }, [_c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "14.096",
      "height": "8.048",
      "viewBox": "0 0 14.096 8.048"
    }
  }, [_c('path', {
    attrs: {
      "fill": "currentColor",
      "d": "M.875-3.25.188-4A.665.665,0,0,1,.25-5.062l6.313-5.781a.6.6,0,0,1,.875,0L13.75-5.062A.665.665,0,0,1,13.813-4l-.687.75a.637.637,0,0,1-.5.266.672.672,0,0,1-.531-.2L7-7.875,1.906-3.187a.672.672,0,0,1-.531.2A.637.637,0,0,1,.875-3.25Z",
      "transform": "translate(0.048 11.031)"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "article__content--box__content",
    attrs: {
      "aria-expanded": _vm.articleSettingsBoxActive
    }
  }, [_c('div', {
    staticClass: "article__form-group"
  }, [_c('div', {
    staticClass: "article__form-group--full"
  }, [_c('div', {
    staticClass: "article__form-element"
  }, [_c('label', {
    staticClass: "article__form-label",
    attrs: {
      "for": "company-specific"
    }
  }, [_vm._v("Company specific")]), _vm._v(" "), _c('v-select', {
    staticClass: "form-control form-control__select",
    class: [{
      'has-error': _vm.errors.has('Company specific')
    }],
    attrs: {
      "searchable": true,
      "multiple": true,
      "options": _vm.getCompaniesForSelect,
      "disabled": (_vm.isSpecific !== null && _vm.isSpecific === 'industry') || _vm.isExcluded !== null,
      "data-vv-name": "Company specific",
      "data-lpignore": "true",
      "name": "company",
      "id": "company-specific"
    },
    model: {
      value: (_vm.entity.company),
      callback: function($$v) {
        _vm.$set(_vm.entity, "company", $$v)
      },
      expression: "entity.company"
    }
  }), _vm._v(" "), (this.errors.has('Company specific')) ? _c('span', {
    staticClass: "form-field-error"
  }, [_vm._v(_vm._s(this.errors.first('Company specific')))]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "article__form-element"
  }, [_c('label', {
    staticClass: "article__form-label",
    attrs: {
      "for": "industry-specific"
    }
  }, [_vm._v("Industry specific")]), _vm._v(" "), _c('v-select', {
    staticClass: "form-control form-control__select",
    class: [{
      'has-error': _vm.errors.has('Industry specific')
    }],
    attrs: {
      "searchable": true,
      "multiple": true,
      "options": _vm.getIndustriesForSelect,
      "disabled": (_vm.isSpecific !== null && _vm.isSpecific === 'company') || _vm.isExcluded !== null,
      "data-vv-name": "Industry specific",
      "data-lpignore": "true",
      "name": "industry",
      "id": "industry-specific"
    },
    model: {
      value: (_vm.entity.industry),
      callback: function($$v) {
        _vm.$set(_vm.entity, "industry", $$v)
      },
      expression: "entity.industry"
    }
  }), _vm._v(" "), (this.errors.has('Industry specific')) ? _c('span', {
    staticClass: "form-field-error"
  }, [_vm._v(_vm._s(this.errors.first('Industry specific')))]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "article__form-element"
  }, [_c('label', {
    staticClass: "article__form-label",
    attrs: {
      "for": "location-specific"
    }
  }, [_vm._v("Location specific")]), _vm._v(" "), _c('v-select', {
    staticClass: "form-control form-control__select",
    class: [{
      'has-error': _vm.errors.has('Location specific')
    }],
    attrs: {
      "searchable": true,
      "multiple": true,
      "options": _vm.companyLocations,
      "data-vv-name": "Location specific",
      "data-lpignore": "true",
      "name": "location",
      "id": "location-specific"
    },
    model: {
      value: (_vm.entity.location),
      callback: function($$v) {
        _vm.$set(_vm.entity, "location", $$v)
      },
      expression: "entity.location"
    }
  }), _vm._v(" "), (this.errors.has('Location specific')) ? _c('span', {
    staticClass: "form-field-error"
  }, [_vm._v(_vm._s(this.errors.first('Location specific')))]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "article__form-element"
  }, [_c('label', {
    staticClass: "article__form-label",
    attrs: {
      "for": "company-exclude"
    }
  }, [_vm._v("Exclude companies")]), _vm._v(" "), _c('v-select', {
    staticClass: "form-control form-control__select",
    class: [{
      'has-error': _vm.errors.has('Exclude companies')
    }],
    attrs: {
      "searchable": true,
      "multiple": true,
      "disabled": (_vm.isExcluded !== null && _vm.isExcluded === 'industry') || (_vm.isSpecific !== null && _vm.isSpecific !== 'industry'),
      "options": _vm.getCompaniesForSelect,
      "data-vv-name": "Exclude companies",
      "data-lpignore": "true",
      "name": "notCompany",
      "id": "company-exclude"
    },
    model: {
      value: (_vm.entity.notCompany),
      callback: function($$v) {
        _vm.$set(_vm.entity, "notCompany", $$v)
      },
      expression: "entity.notCompany"
    }
  }), _vm._v(" "), (this.errors.has('Exclude companies')) ? _c('span', {
    staticClass: "form-field-error"
  }, [_vm._v(_vm._s(this.errors.first('Exclude companies')))]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "article__form-element"
  }, [_c('label', {
    staticClass: "article__form-label",
    attrs: {
      "for": "industry-exclude"
    }
  }, [_vm._v("Exclude industries")]), _vm._v(" "), _c('v-select', {
    staticClass: "form-control form-control__select",
    class: [{
      'has-error': _vm.errors.has('Exclude industries')
    }],
    attrs: {
      "searchable": true,
      "multiple": true,
      "disabled": (_vm.isExcluded !== null && _vm.isExcluded === 'company') || _vm.isSpecific !== null,
      "options": _vm.getIndustriesForSelect,
      "data-vv-name": "Exclude industries",
      "data-lpignore": "true",
      "name": "notIndustry",
      "id": "industry-exclude"
    },
    model: {
      value: (_vm.entity.notIndustry),
      callback: function($$v) {
        _vm.$set(_vm.entity, "notIndustry", $$v)
      },
      expression: "entity.notIndustry"
    }
  }), _vm._v(" "), (this.errors.has('Exclude industries')) ? _c('span', {
    staticClass: "form-field-error"
  }, [_vm._v(_vm._s(this.errors.first('Exclude industries')))]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "article__form-element"
  }, [_c('label', {
    staticClass: "article__form-label",
    attrs: {
      "for": "location-exclude"
    }
  }, [_vm._v("Exclude locations")]), _vm._v(" "), _c('v-select', {
    staticClass: "form-control form-control__select",
    class: [{
      'has-error': _vm.errors.has('Exclude locations')
    }],
    attrs: {
      "searchable": true,
      "multiple": true,
      "options": _vm.companyLocations,
      "data-vv-name": "Exclude locations",
      "data-lpignore": "true",
      "name": "notLocation",
      "id": "location-exclude"
    },
    model: {
      value: (_vm.entity.notLocation),
      callback: function($$v) {
        _vm.$set(_vm.entity, "notLocation", $$v)
      },
      expression: "entity.notLocation"
    }
  }), _vm._v(" "), (this.errors.has('Exclude locations')) ? _c('span', {
    staticClass: "form-field-error"
  }, [_vm._v(_vm._s(this.errors.first('Exclude locations')))]) : _vm._e()], 1)])])])]), _vm._v(" "), _c('div', {
    staticClass: "article__content--box"
  }, [_c('div', {
    staticClass: "article__content--box__head",
    class: [{
      'active': _vm.articleRelatedBoxActive
    }]
  }, [_c('div', {
    staticClass: "article__content--box__head--title"
  }, [_vm._v("Related: resources and tasks")]), _vm._v(" "), _c('button', {
    staticClass: "article__content--box__head--action",
    attrs: {
      "aria-expanded": _vm.articleRelatedBoxActive
    },
    on: {
      "click": function($event) {
        _vm.articleRelatedBoxActive = !_vm.articleRelatedBoxActive
      }
    }
  }, [_c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "14.096",
      "height": "8.048",
      "viewBox": "0 0 14.096 8.048"
    }
  }, [_c('path', {
    attrs: {
      "fill": "currentColor",
      "d": "M.875-3.25.188-4A.665.665,0,0,1,.25-5.062l6.313-5.781a.6.6,0,0,1,.875,0L13.75-5.062A.665.665,0,0,1,13.813-4l-.687.75a.637.637,0,0,1-.5.266.672.672,0,0,1-.531-.2L7-7.875,1.906-3.187a.672.672,0,0,1-.531.2A.637.637,0,0,1,.875-3.25Z",
      "transform": "translate(0.048 11.031)"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "article__content--box__content",
    attrs: {
      "aria-expanded": _vm.articleRelatedBoxActive
    }
  }, [_c('div', {
    staticClass: "article__form-group"
  }, [_c('div', {
    staticClass: "article__form-group--full"
  }, [_c('div', {
    staticClass: "article__form-element"
  }, [_c('label', {
    staticClass: "article__form-label",
    attrs: {
      "for": "related-articles"
    }
  }, [_vm._v("Related Resources")]), _vm._v(" "), _c('v-select', {
    staticClass: "form-control form-control__select",
    attrs: {
      "debounce": 250,
      "on-search": _vm.getOptionsThingsToConsider,
      "options": _vm.thingsToConsiderOptions,
      "multiple": true,
      "id": "related-articles",
      "placeholder": "Search..."
    },
    model: {
      value: (_vm.entity.ttc),
      callback: function($$v) {
        _vm.$set(_vm.entity, "ttc", $$v)
      },
      expression: "entity.ttc"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "article__form-element"
  }, [_c('label', {
    staticClass: "article__form-label",
    attrs: {
      "for": "related-tasks"
    }
  }, [_vm._v("Related Tasks")]), _vm._v(" "), _c('v-select', {
    staticClass: "form-control form-control__select",
    attrs: {
      "debounce": 250,
      "on-search": _vm.getOptionsThingsToDo,
      "options": _vm.thingsToDoOptions,
      "multiple": true,
      "id": "related-tasks",
      "placeholder": "Search..."
    },
    model: {
      value: (_vm.entity.ttd),
      callback: function($$v) {
        _vm.$set(_vm.entity, "ttd", $$v)
      },
      expression: "entity.ttd"
    }
  })], 1)])])])])]), _vm._v(" "), (_vm.articleType.type === 'video' || _vm.articleType.type === 'document') ? _c('div', {
    staticClass: "article__content--box"
  }, [_c('div', {
    staticClass: "article__content--box__head",
    class: [{
      'active': _vm.articleResourcesBoxActive
    }]
  }, [_c('div', {
    staticClass: "article__content--box__head--title"
  }, [_vm._v("Useful resources")]), _vm._v(" "), _c('button', {
    staticClass: "article__content--box__head--action",
    attrs: {
      "aria-expanded": _vm.articleResourcesBoxActive
    },
    on: {
      "click": function($event) {
        _vm.articleResourcesBoxActive = !_vm.articleResourcesBoxActive
      }
    }
  }, [_c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "14.096",
      "height": "8.048",
      "viewBox": "0 0 14.096 8.048"
    }
  }, [_c('path', {
    attrs: {
      "fill": "currentColor",
      "d": "M.875-3.25.188-4A.665.665,0,0,1,.25-5.062l6.313-5.781a.6.6,0,0,1,.875,0L13.75-5.062A.665.665,0,0,1,13.813-4l-.687.75a.637.637,0,0,1-.5.266.672.672,0,0,1-.531-.2L7-7.875,1.906-3.187a.672.672,0,0,1-.531.2A.637.637,0,0,1,.875-3.25Z",
      "transform": "translate(0.048 11.031)"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "article__content--box__content",
    attrs: {
      "aria-expanded": _vm.articleResourcesBoxActive
    }
  }, [_c('div', {
    staticClass: "article__form-group"
  }, [_c('div', {
    staticClass: "article__form-group--sixth"
  }, [_vm._l((_vm.entity.resources.video), function(row, index) {
    return (_vm.articleType.type === 'video') ? _c('div', {
      staticClass: "article__resource-row"
    }, [_c('div', {
      staticClass: "article__form-element"
    }, [_c('label', {
      staticClass: "article__form-label",
      attrs: {
        "for": "video-url"
      }
    }, [_vm._v("Video URL")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (row.videoUrl),
        expression: "row.videoUrl"
      }, {
        name: "validate",
        rawName: "v-validate",
        value: ('url'),
        expression: "'url'"
      }],
      staticClass: "form-control form-control__input",
      class: [{
        'has-error': _vm.errors.has('Video URL')
      }],
      attrs: {
        "type": "text",
        "data-lpignore": "true",
        "id": "video-url",
        "data-vv-name": "Video URL",
        "name": "video-url"
      },
      domProps: {
        "value": (row.videoUrl)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(row, "videoUrl", $event.target.value)
        }
      }
    }), _vm._v(" "), (_vm.errors.has('Video URL')) ? _c('span', {
      staticClass: "form-field-error"
    }, [_vm._v(_vm._s(_vm.errors.first('Video URL')))]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "article__form-element"
    }, [_c('label', {
      staticClass: "article__form-label",
      attrs: {
        "for": "video-transcript"
      }
    }, [_vm._v("Transcript for video")]), _vm._v(" "), _c('textarea', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (row.videoTranscript),
        expression: "row.videoTranscript"
      }],
      staticClass: "form-control form-control__textarea",
      attrs: {
        "type": "text",
        "data-lpignore": "true",
        "id": "video-transcript",
        "data-vv-name": "Transcript for video",
        "name": "video-transcript"
      },
      domProps: {
        "value": (row.videoTranscript)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(row, "videoTranscript", $event.target.value)
        }
      }
    })]), _vm._v(" "), (_vm.entity.resources.video.length > 0) ? _c('div', {
      staticClass: "form-element__video-remove",
      on: {
        "click": function($event) {
          return _vm.removeElement(index)
        }
      }
    }) : _vm._e()]) : _vm._e()
  }), _vm._v(" "), _vm._l((_vm.entity.resources.document), function(row, index) {
    return (_vm.articleType.type === 'document') ? _c('div', {
      staticClass: "article__resource-row"
    }, [_c('div', {
      staticClass: "article__form-element"
    }, [_c('span', {
      staticClass: "article__form-label"
    }, [_vm._v("Upload resource")]), _vm._v(" "), _c('label', {
      staticClass: "form-label"
    }, [(row.resource === null) ? _c('span', {
      staticClass: "form-control form-control__input"
    }, [_vm._v("+Upload resource")]) : _vm._e(), _vm._v(" "), (row.resource !== null) ? _c('span', {
      staticClass: "form-control form-control__input",
      attrs: {
        "id": 'uploadedResource_' + index
      }
    }, [_vm._v(_vm._s(row.name))]) : _vm._e(), _vm._v(" "), _c('input', {
      staticClass: "form-control visually-hidden form-control--file input-file-resource",
      attrs: {
        "type": "file",
        "id": 'uploadResource_' + index,
        "placeholder": "Type in to add title..."
      },
      on: {
        "change": function($event) {
          return _vm.onResourceFileChange($event, index)
        }
      }
    })]), _vm._v(" "), (_vm.entity.resources.document.length > 0) ? _c('div', {
      staticClass: "form-element__video-remove",
      on: {
        "click": function($event) {
          return _vm.removeElement(index)
        }
      }
    }) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "article__form-element"
    }, [_c('label', {
      staticClass: "article__form-label",
      attrs: {
        "for": "resource-url"
      }
    }, [_vm._v("Resource URL")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (row.resourceUrl),
        expression: "row.resourceUrl"
      }, {
        name: "validate",
        rawName: "v-validate",
        value: ('url'),
        expression: "'url'"
      }],
      staticClass: "form-control form-control__input",
      class: [{
        'has-error': _vm.errors.has('Resource URL')
      }],
      attrs: {
        "type": "text",
        "data-lpignore": "true",
        "id": "resource-url",
        "data-vv-name": "Resource URL",
        "name": "resource-url"
      },
      domProps: {
        "value": (row.resourceUrl)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(row, "resourceUrl", $event.target.value)
        }
      }
    }), _vm._v(" "), (_vm.errors.has('Resource URL')) ? _c('span', {
      staticClass: "form-field-error"
    }, [_vm._v(_vm._s(_vm.errors.first('Resource URL')))]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "article__form-element"
    }, [_c('label', {
      staticClass: "article__form-label",
      attrs: {
        "for": "resource-transcript"
      }
    }, [_vm._v("Transcript for resource")]), _vm._v(" "), _c('textarea', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (row.resourceTranscript),
        expression: "row.resourceTranscript"
      }],
      staticClass: "form-control form-control__textarea",
      attrs: {
        "type": "text",
        "data-lpignore": "true",
        "id": "resource-transcript",
        "data-vv-name": "Transcript for video",
        "name": "video-transcript"
      },
      domProps: {
        "value": (row.resourceTranscript)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(row, "resourceTranscript", $event.target.value)
        }
      }
    })])]) : _vm._e()
  }), _vm._v(" "), _c('div', {
    staticClass: "article__form-group--full form-group__video-add-button",
    on: {
      "click": _vm.addVideoRow
    }
  }, [_c('div', {
    staticClass: "add-new-video"
  }, [_vm._v("Add new")])])], 2)])])]) : _vm._e()])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "article__content--title"
  }, [_c('h1', [_vm._v("Add article")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-06e839e5","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/AddArticle.vue
// module id = 883
// module chunks = 1